<template>
  <div id="main-content" class="detail-pickup-route">
    <el-col :offset="1" :span="22">
      <PageTitle :title="title" :backLink="backLink"></PageTitle>
      <el-row>
        <el-form :inline="true" class="demo-form-inline">
          <el-form-item>
            <el-button type="success" @click="goToEdit()">{{ $t('common.edit') }}</el-button>
          </el-form-item>
        </el-form>
      </el-row>
      <form v-if="pickupRouteInfo">
        <el-row>
          <el-col :span="12" style="display: inline">
            <span class="form-lable">{{ $t('common.pickup_route_name') }}:</span>
            <span class="info-span"> {{ pickupRouteInfo.name }} </span>
          </el-col>
          <el-col :span="12" style="display: inline">
            <span class="form-lable">{{ $t('common.bus') }}:</span>
            <span class="info-span"> {{ pickupRouteInfo.bus_info ? pickupRouteInfo.bus_info.name : '' }} </span>
          </el-col>
        </el-row>
        <el-row style="padding-top: 20px">
          <el-col :span="24" style="display: inline">
            <span class="form-lable">{{ $t('common.member') }}:</span>
            <ul class="member-list">
              <li v-for="parent in pickupRouteInfo.parent_list" :key="parent.id">
                {{ getParentLabel(parent) }}
              </li>
            </ul>
          </el-col>
        </el-row>
        <el-row class="row-section">
          <h3>{{ $t('bus_stop.bus_stop_list') }}</h3>
        </el-row>
        <el-row style="padding-top: 20px">
          <table class="bus-list">
            <tr>
              <th>#</th>
              <th>{{ $t('common.bus_stop') }}</th>
              <th>{{ $t('common.address') }}</th>
              <th>{{ $t('bus_stop.pickup_time') }}</th>
            </tr>
            <tr v-for="(place, index) in pickupRouteInfo.place_list" :key="place.id">
              <td width="5%">{{ index + 1 }}</td>
              <td width="30%">{{ place.name }}</td>
              <td width="30%">{{ place.address }}</td>
              <td width="20%">{{ place.time }}</td>
            </tr>
          </table>
        </el-row>

      </form>
    </el-col>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import PageTitle from '@/components/PageTitle'

  export default {
    name: "DetailPickupRoute",
    components: {
      PageTitle
    },
    data: function () {
      return {
        title: 'route.pickup_route_information',
        backLink: `/pickup-route?action=back`
      }
    },
    mounted: function () {
      let successCallback = () => {
      };
      let payload = {
        successCallback,
        pickup_route_id: this.$route.query.prid
      }
      this.$store.dispatch('pickuproute/getPickupRouteInfo', payload)
    },
    computed: {
      ...mapState('pickuproute', ['pickupRouteInfo']),
    },
    methods: {
      goToEdit: function () {
        this.$router.push({path: '/pickup-route/edit', query: {prid: this.$route.query.prid}});
      },
      goToRegist: function () {
        this.$router.push({path: '/pickup-route/regist', query: {prid: this.$route.query.prid}});
      },
      getParentLabel (parent) {
        let label = []

        if (parent.name && parent.name.trim()) {
          label.push(parent.name.trim())
        }

        if (parent.furigana && parent.furigana.trim()) {
          label.push(parent.furigana.trim())
        }

        if (parent.email && parent.email.trim()) {
          label.push(parent.email.trim())
        }

        return label.join(' - ')
      }
    }
  }
</script>

<style lang="scss">
  .detail-pickup-route {
    .member-list {
      float: left;
      margin-left: 10px;

      li {
        text-align: left;
        line-height: 40px;
      }
    }
  }
</style>
